import { createSlice } from '@reduxjs/toolkit'

export const AppConfigSlice = createSlice({
  name: 'appConfigInfo',
  initialState: {
    isMobileView: false,
    formData: {},
    isWaitingForUpiApp: null,
    userReturnedFromUpiApp: null,
  },
  reducers: {
    setIsMobileView: (state, action) => {
      state.isMobileView = action.payload
    },
    setFormData: (state, action) => {
      const { code, value } = action.payload;
      state.formData[code] = value;
    },
    setUserReturnedFromUpiApp: (state, action) => {
      state.userReturnedFromUpiApp = action.payload;
    },
    setIsWaitingForUpiApp: (state, action) => {
      state.isWaitingForUpiApp = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setIsMobileView, setFormData, setUserReturnedFromUpiApp, setIsWaitingForUpiApp } = AppConfigSlice.actions

export default AppConfigSlice.reducer